export const supplierServiceCategories = [
  'Engineering Firm',
  'Architect Firm',
  'Interior Designer',
]
